import { render, staticRenderFns } from "./PropertySelection.vue?vue&type=template&id=5d1d8e37&scoped=true"
import script from "./PropertySelection.vue?vue&type=script&lang=js"
export * from "./PropertySelection.vue?vue&type=script&lang=js"
import style0 from "./PropertySelection.vue?vue&type=style&index=0&id=5d1d8e37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d8e37",
  null
  
)

export default component.exports